import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

const TripFilters = ({ filters, setFilters, onReset }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="trip-filters p-3 mb-4 bg-light rounded">
      <h5>Filter Trips</h5>
      <Row>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Search</Form.Label>
            <Form.Control
              type="text"
              name="search"
              value={filters.search}
              onChange={handleChange}
              placeholder="Search trips..."
            />
            <Form.Text className="text-muted">
              Search by name or location
            </Form.Text>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Certification Level</Form.Label>
            <Form.Select
              name="certificationLevel"
              value={filters.certificationLevel}
              onChange={handleChange}
            >
              <option value="">All Levels</option>
              <option value="OW">Open Water</option>
              <option value="AOW">Advanced Open Water</option>
              <option value="Rescue">Rescue Diver</option>
              <option value="DM">Divemaster</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={2}>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleChange}
            >
              <option value="">All Status</option>
              <option value="upcoming">Upcoming</option>
              <option value="ongoing">Ongoing</option>
              <option value="completed">Completed</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={2}>
          <Form.Group className="mb-3">
            <Form.Label>Price Range</Form.Label>
            <Form.Select
              name="priceRange"
              value={filters.priceRange}
              onChange={handleChange}
            >
              <option value="">Any Price</option>
              <option value="0-500">Under 500 EUR</option>
              <option value="500-1000">500 - 1000 EUR</option>
              <option value="1000-2000">1000 - 2000 EUR</option>
              <option value="2000+">2000+ EUR</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={2} className="d-flex align-items-end">
          <Form.Group className="mb-3 w-100">
            <Form.Check
              type="checkbox"
              name="availableOnly"
              label="Available spots only"
              checked={filters.availableOnly}
              onChange={handleChange}
            />
            <Button 
              variant="outline-secondary" 
              size="sm" 
              className="w-100 mt-2"
              onClick={onReset}
            >
              Reset Filters
            </Button>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default TripFilters;
